import { render, staticRenderFns } from "./Optimize.vue?vue&type=template&id=116f1f80&scoped=true"
import script from "./Optimize.vue?vue&type=script&lang=js"
export * from "./Optimize.vue?vue&type=script&lang=js"
import style0 from "./Optimize.vue?vue&type=style&index=0&id=116f1f80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116f1f80",
  null
  
)

export default component.exports